
<nav class="breadcrumb">
    <div class="container">
      <span 
        *ngFor="let step of visibleSteps; let i = index" 
        class="breadcrumb-item"
        [class.active]="step.key === currentStep"
        [class.completed]="canNavigateToStep(step.key) && step.key !== currentStep"
        [style.cursor]="canNavigateToStep(step.key) ? 'pointer' : 'default'"
        (click)="navigateToStep(step.key)">
        {{ step.label }}
        <span *ngIf="i < visibleSteps.length - 1" class="breadcrumb-separator">></span>
      </span>
    </div>
  </nav>
  